import { Head } from '@inertiajs/react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import type { AdminExternalPeopleIndex } from '@/types';
import { CreateExternalPersonDialog } from './components/CreateExternalPersonDialog';
import { ExternalPeopleSearch } from './components/ExternalPeopleSearch';
import { ExternalPeopleTable } from './components/ExternalPeopleTable';

export default function Index({
  people,
  eventSlug,
  eventName,
  search,
  title,
}: AdminExternalPeopleIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">
              External People
            </h1>
            <p className="text-muted-foreground">
              Manage external participants for {eventName}
            </p>
          </div>
          <CreateExternalPersonDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <ExternalPeopleSearch eventSlug={eventSlug} search={search} />
            <p className="text-muted-foreground text-sm">
              {people.length} {people.length === 1 ? 'person' : 'people'} found
            </p>
          </CardHeader>
          <CardContent className="p-0">
            <ExternalPeopleTable eventSlug={eventSlug} people={people} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
